"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _default = function _default() {
  return _I18n.default.lang !== 'en' && !_I18n.default.langEnabled && !_I18n.default.publicPage ? 'en' : _I18n.default.lang;
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/utils/getLang.js
// module id = 213
// module chunks = 5 6 7